export default SELECTORS = {
  WISHLIST_REMOVE_CONFIRMATION_WRAPPER: '.remove-wishlist-confirmation',
  WISHLIST_REMOVE_CONFIRMATION_CONFIRM: '.remove-wishlist-confirmation--confirm',
  WISHLIST_REMOVE_CONFIRMATION_CANCEL: '.remove-wishlist-confirmation--cancel',
  WISHLIST_EMPTY: '.wishlist__empty',
  WISHLIST_GRID: '.wishlist__grid',
  WISHLIST_GRID_WRAPPER: '.wishlist__grid--wrapper',
  WISHLIST_ADD_TO_CART_DATASET: '[add-wishlist-to-cart]',
};
